// Mock data for development/preview mode
export const mockFirms = [
  { id: '1', name: 'Axi', industry: 'Financial Services', website: 'https://www.axi.com', logo: '/logos/axi.png' },
  { id: '2', name: 'Capital.com', industry: 'Financial Services', website: 'https://www.capital.com', logo: '/logos/capital.com.png' },
  { id: '3', name: 'CMC', industry: 'Financial Services', website: 'https://www.cmcmarkets.com', logo: '/logos/cmc.jpg' },
  { id: '4', name: 'Control Now', industry: 'Compliance & Regulation', website: '', logo: '/logos/control now.jpg' },
  { id: '5', name: 'EC Markets', industry: 'Financial Services', website: '', logo: '/logos/ec markets.png' },
  { id: '6', name: 'Equiti', industry: 'Financial Services', website: 'https://www.equiti.com', logo: '/logos/equiti.png' },
  { id: '7', name: 'eToro', industry: 'Financial Services', website: 'https://www.etoro.com', logo: '/logos/eToro.png' },
  { id: '8', name: 'Finalto', industry: 'Financial Technology', website: 'https://www.finalto.com', logo: '/logos/Finalto.png' },
  { id: '9', name: 'Fortrade', industry: 'Financial Services', website: 'https://www.fortrade.com', logo: '/logos/fortrade.jpg' },
  { id: '10', name: 'GMG', industry: 'Financial Services', website: '', logo: '/logos/GMG.jpg' },
  { id: '11', name: 'IG', industry: 'Financial Services', website: 'https://www.ig.com', logo: '/logos/IG.png' },
  { id: '28', name: 'Infinox', industry: 'Trading', website: 'https://www.infinox.com', logo: '/logos/infinox.png' },
  { id: '12', name: 'Kaizen Reporting', industry: 'Compliance & Regulation', website: '', logo: '/logos/Kaizen reporting.png' },
  { id: '13', name: 'KOR', industry: 'Financial Services', website: '', logo: '/logos/KOR.png' },
  { id: '14', name: 'LMAX Broker', industry: 'Financial Services', website: 'https://www.lmaxbroker.com', logo: '/logos/LMAX broker.avif' },
  { id: '15', name: 'Maybank Securities', industry: 'Financial Services', website: '', logo: '/logos/Maybank securities.jpeg' },
  { id: '16', name: 'OANDA', industry: 'Financial Services', website: 'https://www.oanda.com', logo: '/logos/OANDA.png' },
  { id: '17', name: 'Pepperstone', industry: 'Financial Services', website: 'https://www.pepperstone.com', logo: '/logos/pepperstone.jfif' },
  { id: '29', name: 'Plus 500', industry: 'Trading', website: 'https://www.plus500.com', logo: '/logos/Plus500.webp' },
  { id: '18', name: 'Qomply', industry: 'Compliance & Regulation', website: '', logo: '/logos/qomply.jpg' },
  { id: '19', name: 'Reg-X Innovations', industry: 'Compliance & Regulation', website: '', logo: '/logos/reg-x innovations.jpg' },
  { id: '20', name: 'Regulatory Advice', industry: 'Compliance & Regulation', website: '', logo: '/logos/RegulatoryAdvice.jpeg' },
  { id: '21', name: 'S&P Cappitech', industry: 'Financial Technology', website: '', logo: '/logos/S&P Cappitech.jpg' },
  { id: '22', name: 'Spreadex', industry: 'Financial Services', website: 'https://www.spreadex.com', logo: '/logos/spreadex.png' },
  { id: '23', name: 'StoneX', industry: 'Financial Services', website: 'https://www.stonex.com', logo: '/logos/stonex.png' },
  { id: '24', name: 'Tickmill', industry: 'Financial Services', website: 'https://www.tickmill.com', logo: '/logos/tickmill.png' },
  { id: '25', name: 'TRAction', industry: 'Financial Services', website: '', logo: '/logos/traction.jfif' },
  { id: '26', name: 'Trading 212', industry: 'Financial Services', website: 'https://www.trading212.com', logo: '/logos/Trading-212.jpg' },
  { id: '27', name: 'XTB', industry: 'Financial Services', website: 'https://www.xtb.com', logo: '/logos/XTB.webp' },
];

export const mockDocuments = [
  {
    id: '1',
    title: 'Meeting Minutes — March 2026',
    url: '#',
    category: 'Meeting Minutes',
    date: 'Mar 18, 2026',
  },
  {
    id: '2',
    title: 'Meeting Minutes — December 2025',
    url: '#',
    category: 'Meeting Minutes',
    date: 'Dec 12, 2025',
  },
  {
    id: '3',
    title: 'Meeting Minutes — September 2025',
    url: '#',
    category: 'Meeting Minutes',
    date: 'Sep 24, 2025',
  },
  {
    id: '4',
    title: 'UPI Best Practice Paper v2.1',
    url: '#',
    category: 'Best Practice',
    date: 'Feb 28, 2026',
  },
  {
    id: '5',
    title: 'EMIR Reporting Guidelines v3.2',
    url: '#',
    category: 'Regulatory',
    date: 'Jan 15, 2026',
  },
  {
    id: '6',
    title: 'FCA CP25/32 Submission Response',
    url: '#',
    category: 'Regulatory',
    date: 'Apr 5, 2026',
  },
  {
    id: '7',
    title: 'Margin & Collateral Survey Results',
    url: '#',
    category: 'Survey',
    date: 'Mar 10, 2026',
  },
];

export const mockBestPractices = [
  {
    id: '1',
    title: 'UPI Generation & Settlement Types',
    content:
      'Guidance on generating Unique Product Identifiers and mapping settlement types for CFD and spread betting products under MiFIR transaction reporting requirements.',
    category: 'UPI',
    author: 'RDF Technical Committee',
  },
  {
    id: '2',
    title: 'FX CFD Notional Amount Reporting',
    content:
      'Best practices for calculating and reporting notional amounts for foreign exchange derivatives under EMIR and MiFIR regulations.',
    category: 'Notional Amounts',
    author: 'RDF Technical Committee',
  },
  {
    id: '3',
    title: 'Margin & Collateral Field Reporting',
    content:
      'Standards for reporting margin and collateral information across multiple regulatory jurisdictions including the UK, EU, and ASIC regimes.',
    category: 'Margin Reporting',
    author: 'RDF Technical Committee',
  },
  {
    id: '4',
    title: 'Equity Forward — Missing ISIN Handling',
    content:
      'How to manage equity forward instruments that lack ISIN codes and the approved workarounds for regulatory reporting.',
    category: 'Product Classification',
    author: 'RDF Technical Committee',
  },
  {
    id: '5',
    title: 'UTI Formatting Requirements',
    content:
      'Comprehensive guide to Unique Trade Identifier formatting standards across EMIR, MiFIR, and international equivalents.',
    category: 'Trade Identifiers',
    author: 'RDF Technical Committee',
  },
];

export const mockDiscussions = [
  {
    id: '1',
    title: '📌 FCA CP25/32 — Industry Response',
    preview: 'Ongoing discussion on the FCA\'s consultation paper on transaction reporting requirements for retail derivatives.',
    replies: 14,
    date: 'Active',
  },
  {
    id: '2',
    title: 'ASIC 2026 Reporting Roadmap',
    preview: 'Members sharing insights on ASIC\'s updated reporting requirements for Australian derivative brokers.',
    replies: 9,
    date: 'Feb 2026',
  },
  {
    id: '3',
    title: 'South Africa Reporting Equivalence',
    preview: 'Discussion on regulatory requirements and equivalence determinations for South African derivatives brokers.',
    replies: 6,
    date: 'Jan 2026',
  },
  {
    id: '4',
    title: 'CTP Readiness & Implementation',
    preview: 'Thread covering CTP certification requirements, testing protocols, and implementation timelines.',
    replies: 11,
    date: 'Feb 2026',
  },
  {
    id: '5',
    title: 'Technical ISINs — Code Assignment',
    preview: 'Discussion on obtaining and managing ISINs for derivative products and handling gaps in code assignment.',
    replies: 8,
    date: 'Mar 2026',
  },
];
